import styled, { css } from 'styled-components';
import { animations } from 'ui-components/src/components/atoms/animations';
import { Modal } from 'ui-components/src/components/atoms/Modal';
import { Scrollbar } from 'ui-components/src/components/atoms/Scrollbar';

export const StyledModal = styled(Modal)`
  & header {
    margin-bottom: 0;
  }

  & .content {
    height: 30rem;
    max-height: 80vh;
    overflow: auto;
    ${css`
      ${Scrollbar.secondary.join('')}
    `};
  }
`;

export const EmbedContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  padding-top: 1rem;
  animation: ${() => css`
    ${animations.fadeIn} 0.1s linear
  `};
  padding: 1.5rem;
`;
